export const foundationTypographyTokens = {
  body: {
    sm: 'text-sm',
    xs: 'text-xs'
  },
  label: {
    default: 'text-sm font-medium',
    compact: 'text-xs font-medium'
  },
  heading: {
    sm: 'text-base font-semibold'
  },
  avatar: {
    xs: 'text-[10px]',
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-2xl'
  }
} as const;